<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row v-for="n in 2" :key="n">
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <div class="text-h4 mb-4" v-if="edicao === 'false' || !edicao">
        Cadastro de Grupo de Captura
      </div>
      <v-row>
        <v-col cols="6">
          <v-text-field
            dense
            :value="form.description.toUpperCase()"
            :error-messages="descriptionErrors"
            :counter="30"
            label="Descrição do Grupo"
            outlined
            @input="
              $v.form.description.$touch()
              form.description = $event.toUpperCase().trim()
            "
            @blur="$v.form.description.$touch()"
          />
        </v-col>
      </v-row>
      <v-divider dark vertical />
      <v-divider dark />
      <v-divider dark vertical />
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule } from '@/utils/vuexUtils'

import gruposCapturaStore from '../_store'
import { validateData, validateComputed } from '../_validates'
import GruposHttpService from '../_services/GruposHttpService'

export default {
  name: 'CadastroGrupoCaptura',
  props: {
    edicao: String,
    _id: String,
  },
  components: { Snackbar, FixedButtons },
  mixins: [validationMixin],
  data: () => ({
    form: {
      description: '',
      tipo: 'GRUPOCAPTURA',
    },
    text: '',
    snackbar: false,
    showSkeleton: true,
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('cadastroGrupoCapturaModulePABXStore', ['getGrupoCapturaSelecionado']),
    ...validateComputed,
  },

  async created() {
    registerVuexModule(this.$store, 'cadastroGrupoCapturaModulePABXStore', gruposCapturaStore)

    if (this.edicao === 'true') {
      this.form = this.getGrupoCapturaSelecionado
    }

    this.showSkeleton = false
  },

  methods: {
    async salvar() {
      this.pararLoader.parar = false

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }
      try {
        if (this.edicao === 'true') {
          await GruposHttpService.putGrupo(this.form)
        } else {
          await GruposHttpService.postGrupo(this.form)
        }
        this.$router.push({ name: 'Grupos' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'Grupos' })
    },
  },
}
</script>
